<template>
  <div>您已退出工单系统，可关闭本页面。</div>
</template>

<script>
export default {
  mounted(){
    //window.open("about:blank","_self").close()
  }
}
</script>